import useCheckoutState from '../../hooks/useCheckoutState';
import { PAGE_TYPES } from '../../enums/page-types';
import { checkoutBookerDomainRule, checkoutGuestSettings } from './checkoutGuests';
import checkGuestsBeforePay from './checkGuestsBeforePay';

/** The attendee check every way to pay runs first (Pay, test card, Apple Pay and Google Pay). */
export default function useGuestsBeforePay() {
  const { checkout, form, formRef, isUpsell, setForm, setFormError } = useCheckoutState();
  const setFormStateByKey = (key, value) => setForm(current => ({ ...current, [key]: value }));
  const showGuests =
    checkout?.type === PAGE_TYPES.EVENT && !isUpsell && Boolean(checkoutGuestSettings(checkout));

  const checksBooker =
    checkout?.type === PAGE_TYPES.EVENT && !isUpsell && Boolean(checkoutBookerDomainRule(checkout));

  const guestsReadyToPay = () => {
    if (!checksBooker) return true;
    const check = checkGuestsBeforePay(checkout, form);
    if (check.ok) return true;

    const panel = form.guestPanel ?? {};
    if (check.bookerFieldId) {
      setFormStateByKey('guestBookerError', {
        fieldId: check.bookerFieldId,
        message: check.message,
      });
    }
    if (check.pendingGuest !== undefined) {
      setFormStateByKey('guestPanel', {
        ...panel,
        open: check.pendingGuest,
        pending: check.pendingGuest,
      });
      // The row may only open on the next render.
      requestAnimationFrame(() =>
        formRef.current?.querySelector(`[data-guest-row="${check.pendingGuest}"]`)?.focus(),
      );
    } else if (check.bookerFieldId) {
      formRef.current
        ?.querySelector(`[name="${check.bookerFieldId}"]`)
        ?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    } else {
      setFormStateByKey('guestPanel', { ...panel, open: check.openGuest });
      setFormError(check.message);
    }
    return false;
  };

  return { showGuests, guestsReadyToPay };
}
